module.exports = __webpack_public_path__ + "img/123-579577.png";